import { render } from "./PaperListViewer.vue?vue&type=template&id=3cca3598&scoped=true"
import script from "./PaperListViewer.vue?vue&type=script&lang=js"
export * from "./PaperListViewer.vue?vue&type=script&lang=js"

import "./PaperListViewer.vue?vue&type=style&index=0&id=3cca3598&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1487974345/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cca3598"]])

export default __exports__